import React from 'react';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import Button from '../Shared/components/controls/Button';
import clsx from 'clsx';

const JoinFamily = (props) => (
  <div className={clsx('container', 'add-margins', props?.params?.Styles)}>
    <div className="joinFamily">
      <Image field={props?.fields.image} />
      <div className="row align-center">
        <div className="col-md-1" />
        <div className="col-md-8">
          <div className="caption">
            <h2>
              <Text field={props?.fields.heading} />
            </h2>
            <p>
              <Text field={props?.fields.text} />
            </p>
            {props?.fields?.hyperLink?.value?.text && (
              <Button link={props?.fields.hyperLink} variant="contained" color="primary">
                {props?.fields.hyperLink.value.text}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default JoinFamily;
